// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flashObject{pointer-events:all}.flashObject.pointerevents{pointer-events:none}.wholeboxvisor .flashObject{pointer-events:all}.wholeboxvisor .flashObject.pointerevents{pointer-events:all}", "",{"version":3,"sources":["webpack://./plugins/FlashObject/_flashObject.scss"],"names":[],"mappings":"AAAA,aACE,kBAAA,CACA,2BACE,mBAAA,CAIF,4BACE,kBAAA,CACA,0CACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
